export default __webpack_public_path__ + "static/media/905.ae55586f.gif";